import { ADMIN_ROUTES } from '~/constants/router'
import { lazyRetry } from '~/utils/lazyRetry'

import { adminRoles } from '~/modules/auth/conditions'

const CommentList = lazyRetry(() => import('~/pages/Comment/List'))
const PantryReviews = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.ReviewsPage })),
)

const ReviewRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}/reviews`,
    component: CommentList,
    pantryComponent: PantryReviews,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Reviews List',
  },
]

export default ReviewRouters
